import wtaAnalyticsLogic from '@src/state/analytics/logic'
import appLogic from '@src/state/app/logic'
import authLogic from '@src/state/auth/logic'
import { checkLogic } from '@src/state/checks/logic'
import { documentLogic } from '@src/state/document/logic'
import humanHelpLogic from '@src/state/expertcheck/logic'
import initializeGTMLogic from '@src/state/gtm/logic'
import { modalLogic } from '@src/state/modals/logic'
import { papersLogic } from '@src/state/papers/logic'
import { paymentLogic } from '@src/state/payment/logic'
import pusherLogic from '@src/state/pusher/logic'
import workspaceLogic from '@src/state/workspace/logic'

const rootLogic = [
  ...checkLogic,
  ...papersLogic,
  ...documentLogic,
  ...authLogic,
  ...modalLogic,
  ...initializeGTMLogic,
  ...appLogic,
  ...workspaceLogic,
  ...wtaAnalyticsLogic,
  ...pusherLogic,
  ...paymentLogic,
  ...humanHelpLogic,
]

export default rootLogic



// WEBPACK FOOTER //
// ./src/state/logics.ts